import { useNavigate } from "react-router";
import { Box, Typography, Alert, Button, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FoodsIcon } from "@foodpilot/foods";

type SettingsErrorProps = {
    heading: string;
    message: string;
};
export const SettingsError = (props: SettingsErrorProps) => {
    const { heading, message } = props;

    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Box sx={{ padding: "32px" }}>
            <Paper
                elevation={0}
                sx={{
                    border: "1px solid #E7E6E4",
                    borderRadius: "16px",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "32px",
                        borderBottom: "1px solid #E7E6E4",
                        backgroundColor: "white",
                    }}
                >
                    <Box
                        onClick={() => navigate(-1)}
                        sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "& svg": {
                                strokeWidth: "2px",
                                stroke: "currentColor",
                            },
                        }}
                    >
                        <FoodsIcon icon="arrowLeftShort" size={6} />
                    </Box>
                    <Typography variant="number-inter" sx={{ lineHeight: "1.6em", color: "#1E1E1E" }}>
                        {heading}
                    </Typography>
                </Box>

                <Box sx={{ padding: "32px" }}>
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {message}
                    </Alert>
                    <Button
                        variant="contained"
                        onClick={() => window.location.reload()}
                        sx={{
                            background: "linear-gradient(180deg, primary.main 0%, primary.light 100%)",
                            borderRadius: "44px",
                            px: 2.5,
                            py: 1.25,
                            height: "40px",
                            textTransform: "none",
                            fontSize: "0.875rem",
                            fontWeight: 700,
                            color: "white",
                        }}
                    >
                        {t("refresh", "Refresh Page")}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};
